export { browserHistory as history } from './store';
export { browserHistory as default } from './store';
